<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Create Report</h2>
  </div>
</div>

<div class="card">

  <form [formGroup]="addreport" (ngSubmit)="saveReport()">
      <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input"
                         type="text"
                         pInputText
                         formControlName="reportCategoryName"
                         autocomplete="off"
                         readonly="readonly" />
                  <label for="float-input" class="f1">Category</label>
              </span>
          </div>
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input1"
                         type="text"
                         appFormErrorMessages
                         pInputText
                         formControlName="reportDisplayName"
                         autocomplete="off" />

                  <label for="float-input1">
                      <span class="required-asteric"> * </span>Display Name
                  </label>
              </span>
          </div>
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input2"
                         type="text"
                         appFormErrorMessages
                         pInputText
                         formControlName="reportFileName"
                         autocomplete="off" />
                  <label for="float-input2">
                      <span class="required-asteric"> * </span>Report File Name
                  </label>
              </span>
          </div>
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input3"
                         type="text"
                         appFormErrorMessages
                         pInputText
                         formControlName="reportShortNote"
                         autocomplete="off" />
                  <label for="float-input3">
                      <span class="required-asteric"> * </span>Report Short Note
                  </label>
              </span>
          </div>

          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <p-dropdown [options]="reportDsnList"
                              formControlName="reportDsnName"
                              dataKey="dsn"
                              placeholder="-- Select --"
                              optionLabel="dsn">
                  </p-dropdown>
                  <label for="float-input3">
                      <span class="required-asteric"> * </span>Report DSN
                  </label>
              </span>
          </div>

          <div class="field-checkbox col-12 md:col-12">
              <p-checkbox name="chkptflag"
                          value="Y"
                          label=""
                          binary="true"
                          formControlName="patientFlag"></p-checkbox>
              <label for="chkptflag">Patient Specific Report</label>
          </div>
          <div class="field col-1 md:col-1 mt-3">
              <button pButton
                      type="submit"
                      icon="pi pi-save"
                      label="Save"
                      class="ui-button-success"></button>
          </div>
      </div>
  </form>
  <div
    class="col-12 p-messages p-messages-summary border-radius-5"
    *ngIf="ShowErrorSummary"
  >
    <span style="font-size: 14px">{{ errorValidationSummary }}</span>
  </div>
</div>
